<template>
	<form class="wide" @submit.prevent="submit">
		<loader v-if="!form.isReady()"/>
		<template v-else>
			<fieldset>
				<div>
					<div>
						<legend><span>Details</span></legend>
					</div>
					<div>
						<label><span>Name </span>
							<div v-if="form.errors.get('name')" class="error-block">
								<p v-html="form.errors.get('name')"></p>
							</div>
							<div>
								<input v-model="form.data.name" type="text">
							</div>
						</label>
					</div>
				</div>
			</fieldset>
			<fieldset>
				<div>
					<div>
						<legend><span>Team Members</span></legend>
					</div>
					<div>
						<label><span>Members </span>
							<div v-if="form.errors.get('members')" class="error-block">
								<p v-html="form.errors.get('members')"></p>
							</div>
							<div>
								<checkbox-manager
									ref="members"
									:all-items="form.options.members"
									:checked="form.optionsByFieldArray('members', 'members')"
									:itemLabelRender="(item) => $present('fullName', item.profile)"
									v-on:valuesChanged="(items) => form.set('members', items)"/>
							</div>
						</label>
					</div>
				</div>
			</fieldset>
			<div class="actions">
				<ul>
					<li>
						<process-button
							:processing="form.processing" :text="$attrs.cta" class="button button--primary"/>
					</li>
				</ul>
			</div>
		</template>
	</form>
</template>
<script>
import {createNamespacedHelpers} from "vuex";

const {mapActions} = createNamespacedHelpers("teams");

export default {

	data() {
		return {
			form: this.newForm({
				name: "",
				members: [],
			}),
		};
	},

	props: {
		team: null,
		method: {
			type: String,
			default() {
				return "post";
			},
		},
	},

	methods: {
		...mapActions([
			"addModel",
			"updateModel",
		]),
		async submit() {
			if ("post" === this.method) {
				this.form.post("teams").then(response => {
					this.$router.replace({
						name: "teams.edit", params: {
							"team": response.data.id,
						},
					});
				});
			}

			if ("patch" === this.method) {
				this.form.patch("teams/" + this.team.id).then(data => {
					this.updateModel(data.data);
					this.$store.dispatch("alertsStore/success", "Team Updated");
				});
			}
		},
	},

	created() {
		this.form.prepare();
		http().get("form-data/team").then(response => {
			this.form.setOptions(response.data);

			if (this.team) {
				this.form.prefill(this.team);
				this.form.set("members", _.map(this.team.members, o => o.id));
			}

			this.form.ready();
		});
	},
};
</script>
